import classes from './dropDown/cppDropDown.scss';
import SceDropDown from './dropDown/cppTextDropDown';
import AddEmailDialogBox from './dropDown/addEmailDialogBox';
import EditEmailDialogBox from './dropDown/editEmailAddress';
import SceButton from '../../../../../../../Common/CommonComponents/sceButton';
import { getLocalizedStrings } from './dropDown/manageAlertPreferencesDropdownString';


class SetUpEmailDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings('mobileText');
    this.state = {
      isRemoveDialog: false,
      removeUserName: '',
      isRemoveMBLCustomerDialog: false,
      custType: "",
      businessPatner:this.props.businessPartner,
      addEmailDialog: false,
      editEmailDialog: false,
      emailPlaceholder: 'Select Email Address',
      editDialog: false, 
      addEmailAddress: { value: '', isError: false, isValidated: false, errorMsg: '', forceValidate: false, },
      addReEmailAddress: { value: '', isError: false, isValidated: false, errorMsg: '', forceValidate: false, },
      droplist: this.props.dropDownData.emailSet,
      // selectedEmailId : !_.isEmpty(this.props.premiseData.preferEmail) ? this.props.premiseData.preferEmail : 'Select Email Address',
      editEmailAddress: { value: '', isError: false, isValidated: false, errorMsg: '', forceValidate: false, },
      editVal: '',newEmailId:'',
      showHintMessage: false,
      placeholder:!_.isEmpty(this.props.selectedValue) ? this.props.selectedValue : 'Enter Email',
    };
  }
  getEmailList(emailList) {
    let that = this;
    let emailValueArr = emailList.map((obj)=>obj.email);
    emailList = emailList.filter((item, i)=>{
      return emailValueArr.indexOf(item.email) === i;
    });
    let selectBoxEmailList = emailList.map(function (emailId, index) {
      let editVal = emailId.email;
      let emailUI =
        <span className={classes.sceEmailwrap}>
          <span className={classes.sceEmailListStyle}>{emailId.email}</span>

          {emailId.standardIndicatorEmail === "X" ?
            <span className={'pull-right ' + classes.sceEmailDelete + " " + classes.sceTooWrap} id={emailId.email + '_' + index} index={index}>
              <span className={classes.sceQuestion}>?</span> <span className={classes.sceTooltip}> {that.strings.emailTooltip} </span> </span> : <span className={'pull-right ' + classes.sceDelete + " " + classes.sceEmailDelete} id={'modifyChild_'+'emailModify'+emailId.email + '_' + index+ that.props.dropdownDifferentiator} index={index} onClick={() => that.onClickModifyEmail(editVal)} >Modify</span>}

        </span>;
      return {
        name: emailId.email, modifiedName: emailUI, value: emailId.email,
      };
    });
    
    this.setState({ ...this.state, droplist: selectBoxEmailList }, () => { });
  }

  componentWillMount() {
    this.getEmailList(this.props.dropDownData.emailSet);
  }
  componentWillReceiveProps(nextProps){
    this.getEmailList(nextProps.dropDownData.emailSet);
  }
  onAddEmailerDialogClick = () => { 
    this.setState(...this.state, { addEmailDialog: !this.state.addEmailDialog }); 
  }
  onAddEmailConfirmDialogClick = (e,name,value,encNum) => {
    this.props.onModifyCustomerPreference('email', value, null);
    
  }
  onClickModifyEmail = (editVal) =>{
    this.setState({ ...this.state,editVal:editVal,editEmailDialog :true},()=>{});
  }
  onEditEmailerDialogClick = (editVal) => {
    let updatedState = { ...this.state };
    updatedState.editEmailAddress.isError= updatedState.editEmailAddress.value===editVal ? true : (updatedState.droplist.filter(item=> item.name === updatedState.editEmailAddress.value).length > 0) ? true : false;
    updatedState.editEmailAddress.errorMsg= updatedState.editEmailAddress.isError ? updatedState.editEmailAddress.value===editVal ?'Your emails should not match' :'Preference already existing': updatedState.addReEmailAddress.errorMsg;
    !updatedState.editEmailAddress.isError ? updatedState.editEmailDialog = false : null;
    updatedState.editEmailAddress.isError ? this.setState(updatedState) : 
    this.setState(updatedState, () =>{
      this.props.onModifyCustomerPreference('email', this.state.editEmailAddress.value, null);
    });
  }

  retrievedataFromTextBoxes = (data) => {
    if (data.id === 'addEmailAddress') {
         this.setState({ ...this.state, addEmailAddress: { ...this.state.addEmailAddress, isError: data.isError, value: data.value }, addReEmailAddress: {...this.state.addReEmailAddress,isError: !data.isError ? data.value===this.state.addReEmailAddress.value ? false : this.state.addReEmailAddress.value.isError : this.state.addReEmailAddress.value.isError , errorMsg: !data.isError && data.value===this.state.addReEmailAddress.value ? '' : this.state.addReEmailAddress.errorMsg } });
    } else if (data.id === 'addReEmailAddress') {
      this.setState({ ...this.state, addReEmailAddress: { ...this.state.addReEmailAddress, isError: data.isError, value: data.value ,errorMsg: !data.isError? '' : this.state.addReEmailAddress.errorMsg} });
    } else if (data.id === 'editEmailAddress') {
      this.setState({ ...this.state, editEmailAddress: { ...this.state.editEmailAddress, isError: data.isError, value: data.value ,errorMsg: !data.isError? '' : this.state.editEmailAddress.errorMsg } });
    }
  }

  handleEmailClick = (data) => {
    this.setState({ deleteValue: data.value },()=>{});
    if (data.value === 'addEmail') {
      this.onAddEmailerDialogClick();
    }else if(data.modifyChild === 'modifyChild'){
      this.onClickModifyEmail(data.value);
    }else{
      this.setState({ newEmailId: data.value },()=>{
        this.onSelectDropDown(data);
      });
    }

  }
  onClickCancelHandler = (e)=>{
    e.preventDefault();
    this.setState({
      ...this.state,editEmailDialog:false,
      addEmailDialog:false ,addEmailAddress: { ...this.state.addEmailAddress, isError: false, errorMsg:'' }, addReEmailAddress: { ...this.state.addReEmailAddress,isError:false, errorMsg:''}, editEmailAddress: { ...this.state.editEmailAddress,isError:false, errorMsg:''}
    },()=>{});
  }
  onSelectDropDown = (e) => {
    var reqObj={...e};
    reqObj.id=this.props.id;
    this.props.onSelectDropDown(reqObj);
  }
  render() {

    return (
      <div>
        <SceDropDown id={'malAddrSelection_'+this.props.dropdownDifferentiator} 
          contactType={"email"}
          selectBoxData={this.state.droplist}
          validator={app.appUtil.validator}
          handleClick={this.handleEmailClick}
          placeholder={this.state.placeholder}
          //defaultText={this.state.selectedEmailId}
          // ariaLabel='mailingAddressSelectBox'
          onDoneEnabledButton={this.props.onDoneEnabledButton}
          onAddEmailerDialogClick={this.onAddEmailerDialogClick}
          onDeleteEmailerDialogClick={this.onDeleteEmailerDialogClick}
          errorMessage={this.props.isDropDownError ? 'Please select email address' : this.props.isSameValueError ? 'Primary and Secondary Contact details cannot be same.':''}
          selectErrorMessage={'Please select email address'}
          defaultText={this.state.selectedEmailId}
          data={this.state.data} 
          isError={this.props.isDropDownError || this.props.isSameValueError}
          triggerOnClick={this.props.triggerOnClick}
          onAddEmailConfirmDialogClick={this.onAddEmailConfirmDialogClick}
          inputButtonText={this.props.inputButtonText}
          addContactValueArr={this.props.addContactValueArr}
        />
        {this.state.addEmailDialog ?
          <AddEmailDialogBox
            onClickCancelHandler={this.onClickCancelHandler}
            onAddEmailerDialogClick={this.onAddEmailerDialogClick}
            retrievedataFromTextBoxes={this.retrievedataFromTextBoxes}
            onAddEmailConfirmDialogClick={this.onAddEmailConfirmDialogClick}
            addEmailAddress={this.state.addEmailAddress}
            addReEmailAddress={this.state.addReEmailAddress} /> : null}

        {this.state.editEmailDialog ?
          <EditEmailDialogBox editVal={this.state.editVal}
            deleteValue={this.state.deleteValue}
            onClickCancelHandler={this.onClickCancelHandler}
            onEditEmailerDialogClick={this.onEditEmailerDialogClick}
            retrievedataFromTextBoxes={this.retrievedataFromTextBoxes}
            editEmailAddress={this.state.editEmailAddress} /> : null}

      </div>
    );
  }
}

export default SetUpEmailDropdown;
